import { Injectable } from '@angular/core';

import { formatDate } from '@angular/common';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
};
@Injectable({
  providedIn: 'root',
})
export class SessionDataService {
  selectedProductId: any;
  selectedSkuId: any;
  selectedPlanType: string = '';
  totalPayAmount: number = -1;
  currentProductType: string = '';
  compareProducts: any[] = [];
  filterResponse: any[] = [];

  productsForCompare: any[] = [];
  machineType: string = '';
  machineHostName: string = '';
  shoppingCart: any = {};
  sessionStartTime: string = '';
  sharedData: any;
  currentPlanStateArr: any[] = [];
  addToCartPayload: any;
  addToCartProductType: string = '';
  savedPartyId: string = '';
  capturedEmail: string = '';
  documntsRequired: boolean = false;
  selectedDocumntToScan: any;

  kioskId: string = '1';
  channel: string = 'inks';
  kioskInfo: any = {};

  httpCallEnabled: boolean = false;
  openPlans: boolean= false;

  partyButtonCheck: boolean = false;

  addon:string='';
  isCheckoutNowFlow = false;

  constructor(private http: HttpClient) {}

  setSelectedProductId(selectedProductId: any): void {
    this.selectedProductId = selectedProductId;
  }
  getSelectedProductId(): any {
    return this.selectedProductId;
  }

  public setSelectedDocumntToScan(selectedDocumntToScan: boolean): void {
    this.selectedDocumntToScan = selectedDocumntToScan;
  }

  public getSelectedDocumntToScan(): any {
    return this.selectedDocumntToScan;
  }

  public setOpenPlans(openPlans: boolean): void {
    this.openPlans = openPlans;
  }

  public isOpenPlans(): boolean {
    return this.openPlans;
  }

  public setDocumntsRequired(documntsRequired: boolean): void {
    this.documntsRequired = documntsRequired;
  }

  public isDocumntsRequired(): boolean {
    return this.documntsRequired;
  }

  setSelectedSkuId(selectedSkuId: any): void {
    this.selectedSkuId = selectedSkuId;
  }

  getSelectedSkuId(): any {
    return this.selectedSkuId;
  }

  setSelectedPlanType(selectedPlanType: string): void {
    this.selectedPlanType = selectedPlanType;
  }

  getSelectedPlanType(): string {
    return this.selectedPlanType;
  }

  setTotalPayAmount(totalPayAmount: number): void {
    this.totalPayAmount = totalPayAmount;
  }

  getTotalPayAmount(): number {
    return this.totalPayAmount;
  }

  setCurrentPlanStateArr(currentPlanStateArr: any): void {
    this.currentPlanStateArr = currentPlanStateArr;
  }

  getCurrentPlanStateArr(): any {
    return this.currentPlanStateArr;
  }

  setSharedData(sharedData: any): void {
    this.sharedData = sharedData;
  }

  getSharedData(): any {
    return this.sharedData;
  }

  setCurrentProductType(currentProductType: string): void {
    this.currentProductType = currentProductType;
  }

  getCurrentProductType(): string {
    return this.currentProductType;
  }

  setCompareProducts(products: any[]): void {
    this.compareProducts = products;
  }

  getCompareProducts(): any[] {
    return this.compareProducts;
  }

  setFilterResponse(filterResponse: any[]): void {
    this.filterResponse = filterResponse;
  }

  getFilterResponse(): any[] {
    return this.filterResponse;
  }

  setProductsForCompare(productsForCompare: any[]): void {
    this.productsForCompare = productsForCompare;
  }

  getProductsForCompare(): any[] {
    return this.productsForCompare;
  }

  setMachineType(machineType: string): void {
    this.machineType = machineType;
  }

  getMachineType(): string {
    return this.machineType;
  }

  deleteShoppingCart(): Observable<any> {
    return this.http.post(environment.BASE_URL + '/deleteCart', httpOptions);
  }
  public getMachineHostName(): string {
    return this.machineHostName;
  }

  public setMachineHostName(machineHostName: string): void {
    this.machineHostName = machineHostName;
  }

  getShoppingCart(): any {
    return this.shoppingCart;
  }

  setShoppingCart(shoppingCart: any): void {
    this.shoppingCart = shoppingCart;
  }

  clearShoppingCart(): void {
    this.shoppingCart = {};
  }

  checkIfCartContainsPlans(): number {
    let numberOfPlans: number = 0;

    if (this.shoppingCart && this.shoppingCart.items) {
      this.shoppingCart.items.forEach((item: any) => {
        if (
          item.commerceItemType &&
          item.commerceItemType === 'mobilePlanSku'
        ) {
          numberOfPlans++;
        }
      });
    }

    return numberOfPlans;
  }

  getPlansAndDevicesCountFromCart(): any {
    let numberOfPlans: number = 0;
    let numberOfDevices: number = 0;
    let smartPayCheck: boolean = false;

    if (this.shoppingCart) {
      this.shoppingCart.items.forEach((item: any) => {
        if (item.commerceItemType) {
          if (item.commerceItemType === 'mobilePlanSku') {
            numberOfPlans++;
          } else if (
            item.commerceItemType === 'mobileDevicesSku' ||
            item.commerceItemType === 'mobileAccessoriesSku'
          ) {
            numberOfDevices++;
            if (
              item.newPostpaidPlan ||
              (item.isExistingAccountNumber &&
                item.accountNumberSelected != null &&
                item.accountNumberSelected != '')
            ) {
              smartPayCheck = true;
            }
          }
        }
      });
    }

    let cartDetailsObj = {
      plansInCart: numberOfPlans,
      devicesInCart: numberOfDevices,
      smartyPayCheck: smartPayCheck,
    };

    return cartDetailsObj;
  }

  setAddToCartPayload(payload: any) {
    this.addToCartPayload = payload;
  }

  getAddToCartPayload(): any {
    let clonePayload = {};
    clonePayload = this.addToCartPayload;
    this.addToCartPayload = {};
    return clonePayload;
  }

  setAddToCartProductType(addToCartProductType: string): void {
    this.addToCartProductType = addToCartProductType;
  }

  getAddToCartProductType(): string {
    return this.addToCartProductType;
  }

  setCapturedEmail(capturedEmail: string): void {
    this.capturedEmail = capturedEmail;
  }

  getCapturedEmail(): string {
    return this.capturedEmail;
  }

  setHttpCallEnabled(httpCallEnabled: boolean) {
    this.httpCallEnabled = httpCallEnabled;
  }

  getHttpCallEnabled(): boolean {
    return this.httpCallEnabled == undefined ? false : this.httpCallEnabled;
  }

  setPartyButtonCheck(partyButtonCheck: boolean) {
    this.partyButtonCheck = partyButtonCheck;
  }

  getPartyButtonCheck(): boolean {
    return this.partyButtonCheck == undefined ? false : this.partyButtonCheck;
  }

  //For QMS Token Generation

  setSessionStartTime(sessionStartTime: string): void {
    this.sessionStartTime = sessionStartTime;
  }

  getSessionStartTime(): string {
    return this.sessionStartTime;
  }

  updateSesssionStartTime(): void {
    this.sessionStartTime = formatDate(
      new Date(),
      'yyyy-MM-dd HH:mm:ss.ms',
      'en-US',
      '+04'
    ).slice(0, -1);
  }

  resetSesssionStartTime(): void {
    this.sessionStartTime = '';
  }

  setChannel(channel: string): void {
    this.channel = channel;
  }

  getChannel(): string {
    return this.channel;
  }

  setKioskId(kioskId: string): void {
    this.kioskId = kioskId;
  }

  getKioskId(): string {
    return this.kioskId;
  }

  setSavedPartyId(savedPartyId: string): void {
    this.savedPartyId = savedPartyId;
  }

  getSavedPartyId(): string {
    return this.savedPartyId;
  }

  setKioskInfo(kioskInfo: any) {
    this.kioskInfo = kioskInfo;
  }

  getKioskInfo(): any {
    return this.kioskInfo;
  }

  resetSessionData(): void {
    this.savedPartyId = '';
    this.capturedEmail = '';
    this.selectedDocumntToScan = {};
  }

  //Invalidate Session
  startNewSession(): Observable<any> {
    return this.http.get(
      environment.BASE_URL + '/invalidateSessionSas',
      httpOptions
    );
  }

  setAddon(addon:string){
    this.addon=addon;
  }

  getAddon():string{
    return this.addon;
  }

  setIsCheckoutNowFlow(c) {
    this.isCheckoutNowFlow = c;
  }

  getIsCheckoutNowFlow() {
    return this.isCheckoutNowFlow;
  }
  
}
